import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Outlet, useLocation } from 'react-router-dom';
import { SheetProvider } from './hooks/useSheet';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingDialog from './components/LoadingDialog';
import {LoadingProvider} from './hooks/useLoading';
import { analytics } from './utils/analytics/zipAnalytics';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializeAnaytics } from './utils/analytics/zipAnalyticUtils';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError(error) {
        console.warn(error);
        return false;
      },
    }
  }
});

initializeAnaytics();

const Appv3 = (): JSX.Element => {

  const location = useLocation();
  React.useEffect(() => {
    analytics.nav(location.pathname + location.search, false);
  }, [location]);

  return (
    <React.Fragment>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <ProtectedRoute>
          <LoadingProvider>
            <React.StrictMode>
              <Outlet />
              <LoadingDialog/>
            </React.StrictMode>
          </LoadingProvider>
        </ProtectedRoute>
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default Appv3;
